import axios from 'axios';
import { serverUrl } from '../../components/Helpers/Config';
import { tokenAuthorize } from '../../components/Helpers/Common';

export const ANALYTICS_MODULE_CARDS_DETIALS = 'ANALYTICS_MODULE_CARDS_DETIALS';

export const getAnalyticsModuleCardDetails = () => {
    return (dispatch, getState) => {
        return axios.get(serverUrl.AnalyticsModuleCardDetails).then(resp => {
            if (resp.status === 200) {
                dispatch({ type: ANALYTICS_MODULE_CARDS_DETIALS, payload: resp.data.results });
            }
        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
        })
    }
}